export const feedPageBreakpoints = {
  mobile: 850,
  hd: 1150,
};
